import { useQuery } from '@tanstack/react-query';

import { cleanObjectEmptyFields } from '@hero/utils';

import { services } from '../../services';

export const useGetThankYouNotes = (
  { recognitionId = '', automationId = '', type = '', page = 1, limit, searchTerm = '' },
  options
) =>
  useQuery(
    ['recognitionThankYouNotes', recognitionId, page, limit, searchTerm],
    () => {
      const params = {
        pagination: {
          limit,
          page: page || 1
        },
        options: {
          exists: [{ field: 'experience.thankYouMessage', exist: true }]
        },
        filters: {
          automationId,
          recognitionId,
          type,
          searchTerm
        }
      };

      return services.orders(cleanObjectEmptyFields(params));
    },
    options
  );
